export const Avatar = ({ name = "", avatarUrl = "", size = "md" }) => {
  const firstLetter = name?.trim()?.charAt(0)?.toUpperCase() || "?";

  const sizeClasses =
    size === "lg" ? "h-16 w-16 text-xl" : "h-12 w-12 text-base";

  if (avatarUrl && avatarUrl.trim() !== "") {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${sizeClasses} rounded-full object-cover`}
      />
    );
  }

  return (
    <div
      className={`
        ${sizeClasses}
        rounded-full
        bg-[#E5E7EB]
        text-gray-700
        flex items-center justify-center
        font-semibold
        uppercase
      `}
    >
      {firstLetter}
    </div>
  );
};
